// Function to toggle cart visibility
function toggleCart() {
  const stsCart = document.querySelector('.stsMainCart');
  stsCart.classList.toggle('tw-translate-x-full');
}

document.addEventListener(
  'DOMContentLoaded',
  function () {
    const stsCartBtn = document.getElementById('stsCartBtn');
    const stsCartCloseBtn = document.getElementById('closeCart');

    // Add click event listener to the cart button
    stsCartBtn.addEventListener('click', toggleCart);
    stsCartCloseBtn.addEventListener('click', toggleCart);

    document.addEventListener('liquid-ajax-cart:request-end', function (event) {
      const { requestState, cart, previousCart, sections } = event.detail;

      // Print out all the available event data
      console.log({ requestState, cart, previousCart, sections });
      if (requestState.requestType === 'add' && requestState.responseData?.ok) {
        toggleCart();
      }
    });
  },
  false,
);

// If you need to toggle the cart from outside the DOMContentLoaded event,
// you can call toggleCart() directly
